import { operators as o, common as c } from '@pendo/aggregations';
import { PRODUCT_AREAS, SUB_PRODUCT_AREAS } from '@/utils/aggregation';

type VisitorMetricsHoverCardAggParams = {
    name?: string;
    timeSeries: c.TimeSeries;
    visitorId: string;
};

export default {
    name: 'VisitorMetricsHoverCardAggregation',
    productArea: PRODUCT_AREAS.ANALYTICS,
    subProductArea: SUB_PRODUCT_AREAS.VISITOR_METRICS_HOVER_CARD,
    responseFormat: 'rows',
    build: ({ name, timeSeries, visitorId }: VisitorMetricsHoverCardAggParams) => {
        return buildVisitorMetricsHoverCardAggregation({
            name,
            timeSeries,
            visitorId,
        });
    },
};

export function buildVisitorMetricsHoverCardAggregation ({ timeSeries, visitorId }: VisitorMetricsHoverCardAggParams) {
    return o.pipeline(
        o.sources.events({ timeSeries, appId: ['expandAppIds("*")'], blacklist: 'apply' }),
        o.visitorFilter(visitorId),
        o.reduce({
            daysActive: o.count('day'),
            totalTimeMinutes: o.sum('numMinutes'),
        }),
        o.select({
            daysActive: 'daysActive',
            totalTime: c.minutesToMilliseconds('totalTimeMinutes'),
            avgTime: 'if(daysActive > 0, (totalTimeMinutes * 60 * 1000)/daysActive, 0)',
        }),
    );
}
